export const tr = {
    all: 'Hepsi',
    'region-except': '{region} ({except} hariç)'
};
